<div #container class="nc-orb-canvas-container"></div>
<div class="nc-content-wrapper">
    <ng-content></ng-content>
</div>